/* -----------------------------------------------------------------------------
 * Application config
 *
 * @description - Application root configaration params
 * -----------------------------------------------------------------------------
 */

export const _cfg = {

  // ------------------------------------------------------------------ [COMMON]

  common: {
    currency: '₽', // available: '₽' or '₸'
    modesCurrency: {
      russian: '₽',
      global: '$'
    },
    modes: ['russian', 'global'], // available broker modes
    smsDelay: 10,
    colors: [
      '#6E30D0',
      '#8A2FD7',
      '#B409D3',
      '#3F51B5',
      '#0084ff',
      '#2EABFF',
      '#009688',
      '#42DC88',
      '#8BC34A',
      '#CDDC39',
      '#FFEB3B',
      '#FFBA00',
      '#FF960A',
      '#FF7510',
      '#FF6114',
      '#FF441A',
      '#f44336',
      '#E91E63',
      '#6E30D0',
      '#8A2FD7',
      '#B409D3',
      '#3F51B5',
      '#0084ff',
      '#2EABFF',
      '#009688',
      '#42DC88',
      '#8BC34A',
      '#CDDC39',
      '#FFEB3B',
      '#FFBA00',
      '#FF960A',
      '#FF7510',
      '#FF6114',
      '#FF441A',
      '#f44336',
      '#E91E63'
    ]
  },

  // ---------------------------------------------------------------- [SECURITY]

  security: {
    csrfMetaName: 'csrf',
    queryParams: [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'type',
      'source',
      'block',
      'position',
      'utm_content',
      'utm_term'
    ],
    redirectLink: 'https://lk.rg.ht/sign-in',
    brands: ['anderida', 'redcircule', 'vinvestor', 'ds', 'scapital'] // available branded params
  },

  // ----------------------------------------------------------------- [DEPOSIT]

  deposit: {
    start: 600000,
    range: {
      min: 30000,
      '2%': 40000,
      '4%': 50000,
      '6%': 60000,
      '8%': 70000,
      '10%': 80000,
      '12%': 90000,
      '14%': 100000,
      '20%': 120000,
      '26%': 150000,
      '32%': 200000,
      '38%': 300000,
      '44%': 400000,
      '50%': 500000,
      '56%': 600000,
      '62%': 700000,
      '68%': 800000,
      '74%': 900000,
      '80%': 1000000,
      '90%': 1500000,
      max: 2000000
    },
    rangeAnderida: {
      min: 30000,
      '2%': 40000,
      '4%': 50000,
      '6%': 60000,
      '8%': 70000,
      '10%': 80000,
      '12%': 90000,
      '14%': 100000,
      '16%': 120000,
      '18%': 150000,
      '20%': 200000,
      '22%': 300000,
      '24%': 400000,
      '26%': 500000,
      '28%': 600000,
      '30%': 700000,
      '32%': 800000,
      '34%': 900000,
      '36%': 1000000,
      '38%': 1500000,
      '40%': 2000000,
      '44%': 3000000,
      '48%': 4000000,
      '52%': 5000000,
      '56%': 6000000,
      '60%': 7000000,
      '64%': 8000000,
      '68%': 9000000,
      '72%': 10000000,
      '76%': 15000000,
      '80%': 20000000,
      '84%': 25000000,
      '88%': 50000000,
      '92%': 100000000,
      '96%': 200000000,
      max: 350000000
    }
  },

  // -------------------------------------------------------------------- [TEXT]

  text: {
    modes: {
      russian: 'Российский рынок',
      global: 'Глобальный рынок'
    },
    tooltips: {
      modes: 'Инвестиции в рублях доступны на бирже ММВБ. Инвестиции в валюте преимущественно осуществляются на мировых биржах',
      deposit: 'Вложения, которые вы планируете инвестировать в ценные бумаги в начале использования сервиса.<br><span class="hl-p">*</span>Вложения могут быть больше суммы доступной на шкале. При работе с реальным счетом, сервис может оперировать любыми доступными суммами.',
      onlyBonds: 'Ваш портфель будет состоять только из надёжных облигаций',
      tpPRoL: 'Инвестиции на фондовом рынке неизбежно сопряжены с различными рисками как макроэкономического плана, так и специфическими рисками компаний. Алгоритм формирования портфеля построен на принципе диверсификации, а для формирования используется целевая функция обеспечивающая оптимальное сочетание риска и дохода. Общее правило инвестирования - чем большую доходность вы хотите получить, тем больший риск нужно принять.',
      tpPRoR: 'В портфель могут быть включены: А) Облигации - низкорисковые активы с фиксированной доходностью. Доход по ним в виде фиксированного купона (процента). Такой доход надежен, но сравним с банковским депозитом. Б) Акции компаний, котирующихся на бирже - инструменты повышенного риска. Доход в виде дивидендов и роста стоимости акций. Доход высокий, но сопряжен с рисками присущими таким компаниям. Доходность и рискованность портфеля определяется соотношением числа акций и облигаций в нем. В) Фонды ETF - продукты с определенной структурой активов.',
      structure: 'Выберите вариант отображения информации по портфелю: Можно посмотреть как общую структуру вложений, так и отдельные инвестиционные инструменты'
    },
    investmentStrategy: {
      modeTitle: 'Планируемые инвестиции:',
      depositTitle: 'Вы вкладываете сегодня:'
    },
    riskStrategy: {
      typeTitle: 'Тип риска:',
      types: [
        'Регулярный доход', // (0) - R
        'Консервативный', // (1 - 25) - R
        'Сбалансированный', // (26-60) - R
        'Умеренно-агрессивный', // (61 - 75) - R
        'Агрессивный' // (76 - 100) - R
      ],
      labels: {
        top: [
          'меньше риск',
          'больше риск'
        ],
        bottom: [
          'меньше доход',
          'больше доход'
        ]
      },
      onlyBonds: 'Только облигации',
      values: [
        'Риск:',
        'Доход:'
      ]
    },
    accountActivation: {
      smsDelay: (v) => `Повтор через ${v} сек`
    },
    portfolioStructure: {
      proportion: [
        'Доля акций:',
        'Доля облигаций:'
      ],
      titles: [
        'ценная бумага',
        'ценные бумаги',
        'ценных бумаг'
      ]
    }
  }

}
